<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                            <div class="col-sm-11 d-flex gap-3 flex-column">
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.exchange_delivery_name.label"
                                                :id="dataSearch.exchange_delivery_name.id"
                                                :placeholder="dataSearch.exchange_delivery_name.placeholder"
                                                :value-default="dataSearch.exchange_delivery_name.value"
                                                @inputValue="onChange($event, dataSearch.exchange_delivery_name.id)"
                                        >
                                        </InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.partner_name.label"
                                                :id="dataSearch.partner_name.id"
                                                :placeholder="dataSearch.partner_name.placeholder"
                                                :value-default="dataSearch.partner_name.value"
                                                @inputValue="onChange($event, dataSearch.partner_name.id)"
                                                :required="dataSearch.partner_name.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.partner_code.label"
                                                :id="dataSearch.partner_code.id"
                                                :placeholder="dataSearch.partner_code.placeholder"
                                                :value-default="dataSearch.partner_code.value"
                                                @inputValue="onChange($event, dataSearch.partner_code.id)"
                                                :required="dataSearch.partner_code.required"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.store_id.label"
                                                :id="dataSearch.store_id.id"
                                                :placeholder="dataSearch.store_id.placeholder"
                                                :value-default="dataSearch.store_id.value"
                                                @inputValue="onChange($event, dataSearch.store_id.id)"
                                                :required="dataSearch.store_id.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputDateTimeNormal
                                                :label="dataSearch.time_created.label"
                                                :id="dataSearch.time_created.id"
                                                :placeholder="dataSearch.time_created.placeholder"
                                                :value-default="dataSearch.time_created.value"
                                                @inputValue="onChange($event, dataSearch.time_created.id)"
                                                :required="dataSearch.time_created.required"
                                        ></InputDateTimeNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-1 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSearch" @click="searchDeliveries"></ButtonSearchComponent>
                            </div>
                        </div>

                    </div>
                    <div class="btn-create-data col-sm-2">
                        <ButtonAddComponent :width="'200px'" :label="labelButtonCreate" @click="redirectToCreate"></ButtonAddComponent>
                    </div>
                    <div class="list-partners-component">
                        <table class="table">
                            <thead>
                            <tr>
                                <th scope="col" style="width: 2%;"><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></th>
                                <th class="text-center" scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-if="listDeliveries.length > 0" v-for="delivery in listDeliveries" :key="delivery.id">
                                    <td><InputCheckboxOne :id="delivery.id" :value-default="checkItems[delivery.id]" @inputValue="onChangeSelectItem($event, delivery.id)" :checked="checkItems[delivery.id]"></InputCheckboxOne></td>
                                    <td class="delivery-name"><p @click="showDeliveryDetail(delivery.id)">{{delivery.exchange_delivery_name}}</p></td>
                                    <td class="text-center"><p>{{delivery.store?.name}}</p></td>
                                    <td class="text-center">{{delivery.partner ? delivery.partner.company_name : ''}}</td>
                                    <td class="text-center">{{CommonService.formatDate(delivery.created_at)}}</td>
                                </tr>
                                <tr v-else>
                                    <td colspan="5" class="text-center">Không có dữ lệu được tìm thấy!</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <PaginateComponent v-if="listDeliveries.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                </div>
            </div>
        </div>
    </div>
</div>
